/**
 * Avisos: siempre se pueden cerrar, tienen duración y nunca tapan zonas de trabajo (prompt §8).
 */

import { create } from 'zustand';

export type TipoAviso = 'info' | 'exito' | 'error' | 'advertencia';

export interface Aviso {
  id: number;
  tipo: TipoAviso;
  texto: string;
}

interface EstadoAvisos {
  avisos: Aviso[];
  mostrar: (texto: string, tipo?: TipoAviso, duracionMs?: number) => void;
  cerrar: (id: number) => void;
}

let siguienteId = 1;

export const useAvisos = create<EstadoAvisos>((set, get) => ({
  avisos: [],
  mostrar: (texto, tipo = 'info', duracionMs = tipo === 'error' ? 12000 : 6000) => {
    const id = siguienteId++;
    set({ avisos: [...get().avisos.slice(-3), { id, tipo, texto }] });
    window.setTimeout(() => get().cerrar(id), duracionMs);
  },
  cerrar: (id) => set({ avisos: get().avisos.filter((a) => a.id !== id) }),
}));

export const avisar = (texto: string, tipo?: TipoAviso, duracionMs?: number) =>
  useAvisos.getState().mostrar(texto, tipo, duracionMs);
